import { useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import type { Json } from "@/integrations/supabase/types";

export const useAnalytics = () => {
  const { user } = useAuth();

  const track = useCallback(
    async (eventName: string, eventData?: Record<string, unknown>) => {
      if (!user) return;
      try {
        await supabase.from("analytics_events").insert({
          user_id: user.id,
          event_name: eventName,
          event_data: (eventData ?? {}) as Json,
        });
      } catch (err) {
        console.error("Analytics track error:", err);
      }
    },
    [user]
  );

  return { track };
};
